import styled from 'styled-components';
export const VisitAttributeRowDiv = styled.div.withConfig({
  displayName: "components__VisitAttributeRowDiv",
  componentId: "n7ses6-0"
})(["display:flex;flex-direction:row;width:100%;flex-wrap:wrap;justify-content:right;"]);
export const VisitAttributeTitle = styled.div.withConfig({
  displayName: "components__VisitAttributeTitle",
  componentId: "n7ses6-1"
})(["color:", ";font-weight:500;font-size:1.2rem;text-decoration:underline;text-align:center;"], props => props.theme.palette.text.secondary);
export const VisitWarningTitle = styled.div.withConfig({
  displayName: "components__VisitWarningTitle",
  componentId: "n7ses6-2"
})(["color:", ";font-weight:500;font-size:1.2rem;text-decoration:underline;text-align:center;padding-bottom:2rem;"], props => props.theme.palette.text.secondary);